import "./globalCapabilityCTA.css";

export default function GlobalCapabilityCTA() {
  return (
    <section className="gc-final-cta">
      <div className="gc-final-cta__container">
        <div className="gc-final-cta__eyebrow">
          <span
            className="gc-final-cta__eyebrow-dot"
            aria-hidden="true"
          />
          LET'S BUILD THE RIGHT FIT
        </div>

        <div className="gc-final-cta__content">
          <h2 className="gc-final-cta__title">
            Looking for the Right
            <br />
            <span>Capability Partner?</span>
          </h2>

          <div className="gc-final-cta__bottom">
            <p className="gc-final-cta__description">
              Tell us about your team, process, or growth requirements.
              We can help you explore the service model that best fits
              your goals.
            </p>

            <a
              href="/contact-us"
              className="gc-final-cta__button"
            >
              <span>Talk to Our Team</span>

              <span
                className="gc-final-cta__button-icon"
                aria-hidden="true"
              >
                ↗
              </span>
            </a>
          </div>
        </div>

        <span
          className="gc-final-cta__background-mark"
          aria-hidden="true"
        >
          Q
        </span>

        <div
          className="gc-final-cta__bottom-line"
          aria-hidden="true"
        />
      </div>
    </section>
  );
}